import { useEffect, useState } from 'react';
import { allPages } from '../services/edulead-v4';
import { eduleadV4 } from '../services/edulead-v4-client';

/**
 * The team's members' emails by member id, for showing who created something the API names
 * only by `creator_id`. Empty until loaded; a failure leaves it empty (the page shows no name).
 */
export function useMemberEmails(): Map<string, string> {
  const [emails, setEmails] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    allPages(eduleadV4.members.list({ page_size: 500 }))
      .then((members) => setEmails(new Map(members.map((m) => [m.id ?? '', m.email ?? '']))))
      .catch((err) => console.error('Failed to load team members:', err));
  }, []);

  return emails;
}
